import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import MainWindow from './components/MainWindow';
import StartBox from "./components/StartBox";

const App = () => {

  const [firstMessage, setFirstMessage] = useState('');
  const [started, setStarted] = useState(false);

  return (
    (() => {

      if (!started) {
        return (
          <StartBox start={() => setStarted(true)} setFirstMessage={setFirstMessage} />
        );
      }

      return <MainWindow firstMessage={firstMessage} />;

    })()
  );

};

ReactDOM.render(
  <App />,
  document.getElementById('ie-chatbot')
);
